import React, { useState } from 'react';

const Modal = ({ isOpen, onClose, showToast }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    details: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    const { name, email, phone, service, details } = formData;
    
    // Create email subject and body
    const subject = `Consultation Request for ${service || 'Service'}`;
    const body = `Name: ${name}\nEmail: ${email}\nPhone: ${phone}\nService: ${service}\n\nProject Details:\n${details}`;
    
    // Open default email client
    window.location.href = `mailto:studiodashweb@gmail.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    
    // Show success message
    showToast('Your email client is opening with pre-filled details. Please click send to complete your request.', 'success');
    
    // Reset form and close modal
    setFormData({
      name: '',
      email: '',
      phone: '',
      service: '',
      details: ''
    });
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="quote-modal active">
      <div className="blur-overlay" onClick={onClose}></div>
      <div className="quote-modal__overlay">
        <div className="quote-modal__container">
          <div className="quote-modal__header">
            <div>
              <h2>Request Consultation</h2>
              <h4>With DashWeb Studio</h4>
            </div>
            <button onClick={onClose}>×</button>
          </div>
          <form id="quoteForm" onSubmit={handleSubmit}>
            <div className="quote-modal__body">
              <p>Please provide details about your project. Your information will be used to pre-fill an email to our team.</p>
            </div>
            <div className="quote-modal__form">
              <input 
                type="text" 
                name="name" 
                placeholder="Full Name" 
                value={formData.name}
                onChange={handleChange}
                required 
              />
              <input 
                type="email" 
                name="email" 
                placeholder="Email Address" 
                value={formData.email}
                onChange={handleChange}
                required 
              />
              <input 
                type="tel" 
                name="phone" 
                placeholder="Phone Number" 
                value={formData.phone}
                onChange={handleChange}
                required 
              />
              <select 
                name="service" 
                value={formData.service}
                onChange={handleChange}
                required
              >
                <option value="">Select Service</option>
                <option value="Web Development">Web Development</option>
                <option value="Mobile Development">Mobile Development</option>
                <option value="Technical Consulting">Technical Consulting</option>
              </select>
              <textarea 
                name="details" 
                rows="4" 
                placeholder="Project Details" 
                value={formData.details}
                onChange={handleChange}
                required
              ></textarea>
              <button type="submit">Open Email with Details</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Modal;